/** Authored SVG path ids with route-specific runtime behaviour. */
export const FLYWAYS_MAP_AFRICAN_EURASIAN_TIMING_REFERENCE_PATH_ID = 'Vector 3';
export const FLYWAYS_MAP_AFRICAN_EURASIAN_LONG_PATH_IDS = [
  'Vector 2',
  'Vector 8',
] as const;
export const FLYWAYS_MAP_AMERICAS_SEAMLESS_LOOP_PATH_ID = 'Vector 159';
export const FLYWAYS_MAP_RUFOUS_HUMMINGBIRD_PATH_ID = 'Vector 155';
export const FLYWAYS_MAP_ARCTIC_TERN_BRANCH_LOOP_PATH_ID = 'Vector 10';
export const FLYWAYS_MAP_AFRICAN_EURASIAN_SPLIT_PATH_ID = 'Vector 158';
export const FLYWAYS_MAP_CENTRAL_ASIA_SPLIT_PATH_ID = 'Vector 161';
export const FLYWAYS_MAP_GREY_HEADED_ALBATROSS_PATH_ID = 'Vector 9';
export const FLYWAYS_MAP_SOUTH_POLAR_SKUA_PATH_ID = 'Vector 12';
